<h4 class="modal-header">{{ isNew ? 'Add' : 'Edit' }} Role</h4>
<div class="modal-body">
    <form [formGroup]="form" autocomplete="off">
        <div class="form-line">
            <div class="form-group">
                <label class="form-label required">Enter Role Name</label>
                <cm-text-input
                    class="inner-component"
                    formControlName="name"
                    [class.error]="nameFormControl.errors && showErrors"
                    (keydown.enter)="form.dirty && submitForm()"
                >
                </cm-text-input>
            </div>
        </div>
        <cm-inline-error class="error-block" [errorMessages]="validationMessages" *ngIf="showErrors"></cm-inline-error>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-default" (click)="onModalClose()">Close</button>
    <button class="btn btn-primary" (click)="submitForm()" [disabled]="!form.dirty">Submit</button>
</div>
